import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { AppConstants, SERVER, LOGON_INFO } from "../app.constants";
import { Cargo } from "../cargo/cargo.service";
import { CommonService } from "../app.service";


@Injectable()
export class MobileService {

    deviceOS: string = "";

    constructor(
        private _htc: HttpClient,
        private commonService: CommonService
    ) {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.search(/iphone|ipad|ipod/) > -1) {
            this.deviceOS = "iOS";
        } else if (ua.search(/android/) > -1) {
            this.deviceOS = "Android";
        }
    }

    getTakenCargoCount(): Observable<any> {
        return this._htc.get(SERVER.baseURL+'/driver-taken-cargo-count/'+LOGON_INFO.CAR_ID+'/');
    }

    //ドライバー配車貨物リストを取得
    getTakenCargoList(): Observable<Cargo[]> {
        return this._htc.get<Cargo[]>(SERVER.baseURL+'/driver-taken-cargo-list/'+LOGON_INFO.CAR_ID+'/');
    }

    getTransHistoryList(page: number): Observable<Cargo[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Cargo[]>(SERVER.baseURL+'/driver-trans-history-list/'+LOGON_INFO.CAR_ID+'/', {params: params});
    }



    getDeviceCurrentLocation() {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    resolve([
                        Math.round(position.coords.latitude * Math.pow(10, 6)) / Math.pow(10, 6),
                        Math.round(position.coords.longitude * Math.pow(10, 6)) / Math.pow(10, 6),
                        Math.round(position.coords.latitude * Math.pow(10, 4)) / Math.pow(10, 4),
                        Math.round(position.coords.longitude * Math.pow(10, 4)) / Math.pow(10, 4)
                    ]);
                },
                function () {
                    reject("端末の位置情報取得に失敗しました。");
                }
            );
        });
    }



    openMapApp(div: string, cargo: Cargo) {
        //let scheme = this.deviceOS === "iPhone" ? 'http' : 'comgooglemaps';
        //let type = this.deviceOS === "iPhone" ? 'apple' : 'google';

        let origin = "";
        let destination = "";

        switch(div) {
            case "originToDestination":
                origin = "&origin="+cargo.load_latitude+','+cargo.load_longitude;
                destination = "&destination="+cargo.drop_latitude+','+cargo.drop_longitude;
                break;
            case "currentToOrigin":
                destination = "&destination="+cargo.load_latitude+','+cargo.load_longitude;
                break;
            case "currentToDestination":
                destination = "&destination="+cargo.drop_latitude+','+cargo.drop_longitude;
                break;
        }

        //location.href = scheme+'://maps.'+type+'.com/maps?saddr=&daddr='+lat+','+lng+'&directionsmode=driving&z=12';
        
        if (this.deviceOS === "iOS") {
            //location.href = "http://maps.apple.com/maps?daddr="+lat+','+lng;
            //location.href = 'comgooglemaps://?saddr=&daddr='+lat+','+lng+'&directionsmode=driving';
            location.href = 'https://www.google.co.jp/maps/dir/?api=1' + origin + destination;
        }
        else {
            location.href = 'https://www.google.co.jp/maps/dir/?api=1' + origin + destination;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/mobile/mobile.service.ts